<script setup lang="ts">
import { ref, computed, defineProps, withDefaults } from 'vue'
import type { UseFuseOptions } from '@vueuse/integrations/useFuse'
import { useFuse } from '@vueuse/integrations/useFuse'
import FuseSearchInput from './FuseSearchInput.vue'

const props = withDefaults(
  defineProps<{
    data: unknown[],
    keys: string[],
    matchAllWhenSearchEmpty?: boolean,
    exactMatchNumber?: number
  }>(),
  {
    matchAllWhenSearchEmpty: true,
    exactMatchNumber: 0.6
  }
)

const options = computed<UseFuseOptions<unknown>>(() => ({
  fuseOptions: {
    keys: props.keys,
    threshold:  props.exactMatchNumber,
    ignoreLocation: true,
  },
  matchAllWhenSearchEmpty: props.matchAllWhenSearchEmpty,
}))

const query = ref('')
const updateQuery = (val: string) => { query.value = val }

const reactiveData = computed(() => props.data)

const { results } = useFuse(query, reactiveData, options);

</script>

<template>
  <div>
    <slot
      name="search"
      :modelValue="query"
      :updateModelValue="updateQuery"
    >
      <FuseSearchInput v-model="query" />
    </slot>
    <slot :results="results.map((result) => result.item)" />
  </div>
</template>
